import ItemHome from '@/views/item/Home.vue'
import ItemList from '@/views/item/ItemList.vue'
import ItemDetail from '@/views/item/ItemDetail.vue'
import ItemClassificationList from '@/views/item/ItemClassificationList.vue'
import ItemImport from '@/views/item/ItemImport.vue'
import OperateItemHome from '@/views/item/operate/Home.vue'
import OperateItemList from '@/views/item/operate/ItemList.vue'
import OperateItemDetail from '@/views/item/operate/ItemDetail.vue'

export default {
  routes: [
    {
      path: '/item',
      component: ItemHome,
      name: 'ItemHome',
      meta: { requiresAuth: true },
      children: [
        {
          path: 'items',
          component: ItemList,
          name: 'ItemList',
        },
        {
          path: 'items/import',
          component: ItemImport,
          name: 'ItemImport',
        },
        {
          path: 'items/:id([0-9]+)',
          component: ItemDetail,
          name: 'ItemDetail',
          props: (route) => ({ id: Number(route.params.id) }),
        },
        {
          path: 'item-classifications',
          component: ItemClassificationList,
          name: 'ItemClassificationList',
        },
      ],
    },
    {
      path: '/operate/item',
      component: OperateItemHome,
      name: 'OperateItemHome',
      meta: { requiresAuth: true },
      children: [
        {
          path: 'items',
          component: OperateItemList,
          name: 'OperateItemList',
        },
        {
          path: 'items/:id([0-9]+)',
          component: OperateItemDetail,
          name: 'OperateItemDetail',
          props: (route) => ({ id: Number(route.params.id) }),
        },
      ],
    },
  ],
}
